import React from 'react';
import { useService } from '@wix/services-manager-react';
import type { IEnvironmentService } from '@wix/viewer-service-environment/definition';
import { EnvironmentDefinition } from '@wix/viewer-service-environment/definition';
import NewButton from './Button';
import LegacyButton from './ButtonLegacy';
import type { ButtonProps } from './ButtonLegacy';

export type { ButtonProps };

const Button: React.FC<ButtonProps> = props => {
  const environmentService = useService(
    EnvironmentDefinition,
  ) as IEnvironmentService;
  const shouldUseNewButton = environmentService?.isExperimentOpen?.(
    'specs.thunderbolt.useERCUndependentComp',
  ) ?? false;

  return shouldUseNewButton ? (
    <NewButton {...props} />
  ) : (
    <LegacyButton {...props} />
  );
};

export default Button;